import React, { useEffect, useState, useMemo } from 'react';
import {
  defaultFormTemplate,directSchemaTemplate,columnLabels,fieldOverrides,validationRules,infoIcons,layout} from '../API/TaskSchema';
import { API_BASE_URL } from 'config';
import { useTaskCreateStore } from '../store/useTaskCreateStore';
import { X } from 'lucide-react';
import FieldInfoIcon from '@components/form-elements/FieldInfoIcon';
//import PreBuildForm from '@components/form-elements/PreBuildForm';
import PreBuildFormNew from '@components/form-elements/PreBuidFormNew';
import CommentsHistory from './CommentsHistory';
import { fetchJson,useGetMetaData,useMatchedMenu } from '@utils/fetchJson';
import { fetchCustomFieldsByMenuId } from '@utils/customFields';
import { toast } from 'react-toastify';
import CustomTaskRepeat from './CustomTaskRepeat';
  const CreateTask = ({onClose, onSave }) => {
  const menuId = useMatchedMenu('task');
  const  menuData = useGetMetaData('task');
  const { isOpen,payload: payloadWrapper, close } = useTaskCreateStore();
  const [defaultFormData, setDefaultFormData] = useState(defaultFormTemplate);
  //const memoFormData = useMemo(() => defaultFormData, [defaultFormData]);
  const customeModules ={
  comments_history: () =>(defaultFormData?.task_id ? <CommentsHistory record_type="task" recordId={payload.record_id} /> : ""),
  custom_task_repeat: () => <CustomTaskRepeat defaultValue={defaultFormData} recordId={payload.record_id} />
  }

  const [initialData, setInitialData] = useState(false);
  const memoizedDirectSchema = useMemo(() => [...directSchemaTemplate], []);
  const memoizedFieldOverrides = useMemo(() => fieldOverrides, []);
  const payload = payloadWrapper?.payload || payloadWrapper || {};
  const onSaveCallback = payload?.onSaveCallback;
  
  const [customFields, setCustomFields] = useState([]);
  
  //Note: Merage all custoom feilds with default
  const [mergedFieldOverrides, setMergedFieldOverrides] = useState(fieldOverrides);
  const [mergedValidationRules, setMergedValidationRules] = useState(validationRules);
  const [mergedColumnLabels, setMergedColumnLabels] = useState(columnLabels);
  const [mergedSchemaTemplate, setMergedSchemaTemplate] = useState(directSchemaTemplate);
  const [mergedLayout, setMergedLayout] = useState(layout);
    
  useEffect(() => {
    if (!isOpen || !menuId) return;
  
    const loadFields = async () => {
        try {
          const {
            injectedLayout,
            customFields,
            extendedDefaults,
            extendedValidations,
            extendedLabels,
            extendedOverrides,
            extendedSchema,
          } = await fetchCustomFieldsByMenuId(menuId, menuData, {
            defaultFormTemplate,
            validationRules,
            fieldOverrides,
            columnLabels,
            directSchemaTemplate,
            layout,
             autoInjectLayout: true,
          });
    
          setCustomFields(customFields);
          setDefaultFormData(extendedDefaults);
          setMergedValidationRules(extendedValidations);
          setMergedColumnLabels(extendedLabels);
          setMergedFieldOverrides(extendedOverrides);
          setMergedSchemaTemplate(extendedSchema);
          setMergedLayout(injectedLayout);
          console.log(extendedDefaults);
         
        } catch (err) {
          toast.error('Failed to load custom fields');
        }
      };
    
      loadFields();
    }, [menuId, isOpen,menuData]);

useEffect(() => {
  const fetchTaskDetails = async () => {
    if (payload?.record_id) {
      try {
        const res = await fetchJson(`${API_BASE_URL}/taskMaster/${payload.record_id}?menuId=${menuId}`, {
          method: 'GET',
        });

        const taskData = res?.data?.[0] || {};
        console.log('Fetched task data:', taskData);

        const resData = {
          ...defaultFormTemplate,
          ...taskData,
          menuId,
        };

        //setDefaultFormData(resData);
        setDefaultFormData((prev) => ({
          ...prev,
          ...resData,
          menuId,
        }));
        
      } catch (err) {
        console.error('Error fetching task:', err);
        setDefaultFormData({ ...defaultFormTemplate, menuId });
      }
    } else {
      // New task — reset form
      console.log("Creating new task — resetting form");
      setDefaultFormData({
        ...defaultFormTemplate,
        menuId,
      });
    }

    setInitialData(true); // only for UI/conditional logic, not as a trigger
  };

  fetchTaskDetails();
}, [payload?.record_id, menuId]);

    const handleSubmit = async (resetAfter = false) => {
    //   if (!validateForm()) return;
      
    //   const url = editId ? updateApi : saveApi;
    //   const method = editId ? 'POST' : 'PUT';
    //   const res = await fetchJson(url, {
    //     method,
    //     body: JSON.stringify(formData)
    //   });
    //   if (res?.flag === 'S') {
    //     toast.success(`Saved successfully`);
    //     onSave?.();
    //     setIsDirty(false);
    //     if (resetAfter) setFormData({});
    //     else onClose();
    //   } else {
    //     toast.error(`Server error: ${res.msg}`);
    //   }
    };

  if (!isOpen) return null;
  return (
    
        <PreBuildFormNew
            menuId={menuId}
            
            getDefApi={`${API_BASE_URL}/getDefinations`}
            saveApi={`${API_BASE_URL}/taskMaster`}
            updateApi={`${API_BASE_URL}/taskMaster/${defaultFormData?.task_id}`}
            //formDataPre={memoFormData}
            formData={defaultFormData}
            setFormData={setDefaultFormData}
            primaryKey="task_id"
            sidebarSize="lg"
            title='Create Task'
            onClose={() => close()}//setShowForm(false)}
            onSave={() => {
              console.log("called back");
              onSaveCallback?.();
              close();
              // Refresh the list or Kanban if needed
            }}
            skipFields={['created_by', 'created_date']}
            directSchema={mergedSchemaTemplate}
            fieldOverrides={mergedFieldOverrides}
            validationRules={mergedValidationRules}
            labels={mergedColumnLabels}
            infoIcons={infoIcons}
            layout={mergedLayout}
            editId={defaultFormData?.task_id}
            recordId={defaultFormData?.task_id}
            customModules={(customeModules ? customeModules : {})}
        />
  );
};

export default CreateTask;
